import { Box, rem, Tooltip } from "@mantine/core";

import { IconAlertTriangle } from "@tabler/icons-react";

import { GA_ALERT_ICON_COLOR, GA_ALERT_TOOLTIP_MESSAGE } from "./constants";
import classes from "./GAAlertMessage.module.css";

/**
 * The overdue-pregnancy warning icon. Its message opens on hover and on a tap, since a hover-only
 * tooltip never shows on a touch screen. The tap stays on the icon: some callers place it inside a
 * button (the EDD row, an encounter row), which would otherwise act on the same tap.
 */
const GAAlertMessage = ({ iconSize = 24 }: { iconSize?: number }) => {
  return (
    <Tooltip
      withArrow
      label={GA_ALERT_TOOLTIP_MESSAGE}
      events={{ hover: true, focus: false, touch: true }}
    >
      <Box
        role="img"
        pl={rem(4)}
        component="span"
        display="inline-flex"
        className={classes.icon}
        data-testid="ga-alert-icon"
        aria-label={GA_ALERT_TOOLTIP_MESSAGE}
        onClick={(event) => event.stopPropagation()}
      >
        <IconAlertTriangle size={iconSize} color={GA_ALERT_ICON_COLOR} />
      </Box>
    </Tooltip>
  );
};

export default GAAlertMessage;
